var _defs, _path, _path2, _path3, _path4, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIcons7 = function SvgSurveyIcons7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "SurveyIcons-7_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".SurveyIcons-7_svg__cls-1{fill:#f68b50}.SurveyIcons-7_svg__cls-2{fill:#4f6b80}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.37 26-1.45-2.86A6.77 6.77 0 0 0 33 10.38l-.41-3.18A10 10 0 0 1 38.37 26Z",
    className: "SurveyIcons-7_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.57 13.48-4.09-4.09a.83.83 0 0 1 0-1.17l4.09-4.1a.83.83 0 0 1 1.43.57v8.19a.83.83 0 0 1-1.42.59Z",
    className: "SurveyIcons-7_svg__cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32.2 19.53-1.62 7.09H14.77l-1.47-7.09h18.9m3-4H8.38l3.14 15.1h21A1.57 1.57 0 0 0 34 29.41l2.72-11.95a1.57 1.57 0 0 0-1.54-1.92Z",
    className: "SurveyIcons-7_svg__cls-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.72 36.15H13.88a2 2 0 0 1-2-1.6L8 15.54H3.28a2 2 0 0 1 0-4h6.4a2 2 0 0 1 2 1.6l3.87 19h15.18a2 2 0 1 1 0 4Z",
    className: "SurveyIcons-7_svg__cls-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.39,
    cy: 38.11,
    r: 2.74,
    className: "SurveyIcons-7_svg__cls-1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.79,
    cy: 38.11,
    r: 2.74,
    className: "SurveyIcons-7_svg__cls-1"
  })));
};
export default SvgSurveyIcons7;